import { useAnalytics } from '@app/analytics/use-analytics';
import { useAppSelector } from '@app/store/store';
import { useCallback } from 'react';

import { selectRecording } from '../selector';
import { getVideoType } from '../utils';

export const useRecordingAnalytics = () => {
  const { track } = useAnalytics();
  const recording = useAppSelector(selectRecording);

  const trackRecordingEvent = useCallback(
    (
      eventName: Parameters<typeof track>[0],
      additionalPayload: Record<string, any> = {},
    ) => {
      track(eventName, {
        videoType: getVideoType(recording),
        recordingDuration: recording?.duration,
        ...additionalPayload,
      });
    },
    [track, recording],
  );

  return {
    trackRecordingEvent,
  };
};
